function clearCurrentSelection(selectElementId) {
    const selectElement = document.getElementById(selectElementId);

    const noRebateOption = selectElement.querySelector('option[value=""][disabled]');
    if (noRebateOption) {
        noRebateOption.remove();
    }
}

function addAlert(message, type, alertId = 'rebateAlert') {
    const alert = document.getElementById(alertId);
    alert.querySelector('.rebate-message').textContent = message;
    alert.style.display = 'block';

    alert.classList.add(type);
}

function clearAlerts(alertId = 'rebateAlert') {
    const alert = document.getElementById(alertId);
    alert.classList.remove('alert-danger');
    alert.classList.remove('alert-success');
}

function addNewOption(selectId, customName, customId = null) {
    const selectElement = document.getElementById(selectId);
    const newOption = document.createElement('option');

    newOption.value = customId !== null ? customId : customName;
    newOption.text = customName;
    newOption.selected = true;
    selectElement.appendChild(newOption);

    clearCurrentSelection(selectId);
}

function getContext() {
    let context = 'modal';
    const rebateElement = document.getElementById('create-rebate');
    if (rebateElement) {
        context = rebateElement.getAttribute('data-context');
    }

    return context;
}

document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('rebateForm');
    const spinnerOverlay = document.getElementById('spinnerOverlay');
    let context = getContext();

    clearAlerts();

    if (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            spinnerOverlay.style.display = 'block';

            const formData = new FormData(form);
            const actionUrl = form.getAttribute('action');

            let isSuccess = false;

            fetch(actionUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    Accept: 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('input[name="_token"]').value,
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (context === 'modal') toggleModal('rebateModal', 'hide');

                    if (data.success) {
                        isSuccess = true;

                        addAlert(data.message, 'alert-success');

                        if (context === 'modal') {
                            addNewOption('rebate_id', data.rebate.name, data.rebate.id);
                        }
                    } else {
                        addAlert(data.message, 'alert-danger');
                    }
                })
                .catch(error => {
                    addAlert(error, 'alert-danger');
                })
                .finally(() => {
                    spinnerOverlay.style.display = 'none';

                    if (isSuccess) {
                        form.reset();
                    }
                });
        });
    }

    document.getElementById('saveCustomRebateType').addEventListener('click', function () {
        const customRebateTypeInput = document.getElementById('customRebateTypeInput');
        const customRebateTypeName = customRebateTypeInput.value.trim();
        const typeId = this.getAttribute('data-type-id');
        const type = typeId ? 'type_id_' + typeId : 'type_id';

        if (customRebateTypeName !== '') {
            addNewOption(type, customRebateTypeName);
            customRebateTypeInput.value = '';
            $('#customRebateTypeModal').modal('hide');
        }
    });
});



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/franchise-locations.js